import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { Paper, Typography, Grid, withStyles, CircularProgress, Theme, createStyles, WithStyles, Chip } from '@material-ui/core'
import RequestTunnel from './step/RequestTunnel'
import { withRouter, RouteComponentProps } from 'react-router'
import CotationRequestProvider, { CotationRequestCtx, CtxCotationRequest } from './CotationRequestProvider'
import Btn from 'src/shared/Btn/Btn'
import { Parallax } from 'react-parallax'
import Alert from 'src/shared/Alert/Alert'
import { Page } from 'src/shared/RcPage'
import * as moment from 'moment-timezone'
import { IProduct, categoryToQP } from 'src/type/product'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { RootState } from 'src/core/redux/reducer'
import { getProductByType } from 'src/core/redux/action/productsAction'
import { UtilsAction } from 'src/core/redux/action/utilsAction'
import { replaceDetteWithTaux } from 'src/shared/utils/helpers'

const headerHeight = 180;

const styles = (t: Theme) => createStyles({
  headerWpr: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      minHeight: `${headerHeight}px`,
      padding: t.spacing.unit * 2,
      marginBottom: t.spacing.unit * 6,
      zIndex: 99,
  },
  contentWpr: {
      marginTop: `-${t.spacing.unit * 3}px`,
      [t.breakpoints.down('xs')]: {
          marginBottom: '50px'
      },
  },
  headerActions: {
      textAlign: 'center'
  },
  productName: {
      color: t.palette.common.white,
  },
  chip: {
      margin: '4px',
      fontSize: '0.75rem',
      height: '26px'
  },
  expansionPnl: {
      boxShadow: 'none',
      '&:before': {
        display: 'none'
      },
  },
  xsScroll: {
      flexDirection: 'column',
      [t.breakpoints.down('sm')]: {
        overflow: 'auto'
      },
  },
  btnCotation:{
      cursor: 'pointer',
      [t.breakpoints.down('xs')]: {
        zIndex: 9999,
        position: 'fixed',
        top: 'auto',
        bottom: 0,
        left: 0,
        width: '100%'
      },
  }
})

interface IProps extends WithI18n, 
WithStyles<typeof styles>,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props>,
RouteComponentProps<any>{
}

class CotationRequest extends React.Component<IProps, {}> {

  render() {
    const {t, classes, product, enterprise} = this.props
    const alerts = this.alertControlQP()

    return (
      <CotationRequestProvider>
          <CotationRequestCtx.Consumer>
            {(other: CtxCotationRequest) => (
              <>
                {product &&
                  <>
                    <Parallax
                        bgImage={product.image_cover_url}
                        bgImageAlt="Arkea banner cover"
                        strength={300}
                    >
                        <div className={classes.headerWpr} id="header">
                            <div>
                                <Typography variant="h4" className={classes.productName} gutterBottom>{product.name}</Typography>
                                {this.categoriesRendering(product as IProduct)}
                            </div>
                            <div className={classes.headerActions}>
                              <Btn
                                  color='primary'
                                  variant='contained'
                                  className={classes.btnCotation}
                                  id="btn-cotation"
                                  style={{marginRight: '5px'}}
                                  onClick={this.cancelCotationRequest}
                              >
                                  {t.cancel}
                              </Btn>
                            </div>
                        </div>
                    </Parallax>
                    <Page className={classes.contentWpr}>
                        <Paper>
                            <div style={{padding: '16px'}}>
                              {!moment(moment(),'hh:mm:ss').isBetween(moment('09:00:00', 'hh:mm:ss').tz('Europe/Paris'), moment('18:00:00', 'hh:mm:ss').tz('Europe/Paris')) &&
                                  <Grid item xs={12} >
                                      <Alert type="info">{t.ProductDetail_alert_cotation}</Alert>
                                      <br/>
                                  </Grid>
                              }
                              {!enterprise.is_pro && alerts && alerts.length > 0 &&
                                  <Grid item xs={12}>
                                    <Alert type="error">
                                      {alerts.map(alert => <p key={alert}>{alert}</p>)}
                                    </Alert>
                                  </Grid>
                              }
                            </div>
                            <Grid container>
                                <Grid item xs={12}>
                                  <RequestTunnel {...other}/>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Page>
                  </>
                }
                {!product &&
                  <CircularProgress size={32}/>
                }
              </>
            )}
          </CotationRequestCtx.Consumer>
      </CotationRequestProvider>
    )
  }

  componentDidMount(){
    const {match, updateProductSelected} = this.props
    this.props.getProduct(match.params.productType).then(res => updateProductSelected(res))
  }

  @autobind
  private alertControlQP() {
    const { enterprise, product, t } = this.props;
    const alertCotationQP = {
      non_approprie: t.Cotation_control_qp_alert_no_appropriate,
      non_repondu: t.Cotation_control_qp_alert_no_appropriate,
      experience: t.Cotation_control_qp_alert_experience_only,
      connaissance: t.Cotation_control_qp_alert_knowledge_only
    }
    const answerShouldBeAlerted = ["non_approprie", "non_repondu", "experience", "connaissance"];
    if(product && product.category_produit && product.category_produit.length > 0){
      const alerts = [];
      product.category_produit.split(",").map(c => {
        const QP = categoryToQP[c];
        const result = enterprise[QP]
        if(result && answerShouldBeAlerted.includes(result)) {
          alerts.push(t[QP] + " : " + alertCotationQP[result])
        }
      })
      return alerts;
    } else {
      return undefined
    }
  }

  @autobind
  private cancelCotationRequest(){
    const {enterprise, match, history} = this.props
    history.push(`/ptf/enterprise/${enterprise.id}/product-detail/${match.params.productType}`)
  }

  @autobind
  private categoriesRendering(p: IProduct){
      const {mapName, classes} = this.props;
      return (
        <>
            {p.category_principale &&
                p.category_principale.split(",").map(c => 
                    mapName.get(c) !== undefined ? <Chip key={`category-principale-${c}`}  label={replaceDetteWithTaux(mapName.get(c))} className={classes.chip} /> : ''
                )
            }
            {p.category_produit &&
                p.category_produit.split(",").map(c => 
                    mapName.get(c) !== undefined ? <Chip key={`category-produit-${c}`}  label={mapName.get(c)} className={classes.chip} /> : ''
                )
            }
            {p.category_actu &&
                p.category_actu.split(",").map(c => 
                    mapName.get(c) !== undefined ? <Chip key={`category-actu-${c}`}  label={mapName.get(c)} className={classes.chip} /> : ''
                )
            }
        </>
      )
  }


}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  enterprise: state.accountInfo.enterpriseSelected,
  product: state.utils.cotationProductSelected
});

const dispatch2props = (dispatch: any) => ({
  updateProductSelected: (product: IProduct) => dispatch(UtilsAction.updateCotatonProductSelected(product)),
  getProduct: (type: string) => dispatch(getProductByType(type)),
});

export default compose(
    withI18n,
    withRouter,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(CotationRequest)



// WEBPACK FOOTER //
// ./src/page/Consumer/Product/cotation/CotationRequest.tsx